import otherReducers from './reducers';

export {default as otherOperations} from './operations';
export {default as otherTypes} from './types';

export default otherReducers;
